// src/store/index.js
import { createStore } from 'vuex';

const store = createStore({
  state: {
    token: localStorage.getItem('token') || '',
    shop: JSON.parse(localStorage.getItem('shop')) || null,

  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    setShop(state, shop) {
      state.shop = shop;
      localStorage.setItem('shop', JSON.stringify(shop));
    },
    logout(state) {
      state.token = '';
      state.shop = null;
      localStorage.removeItem('token');
      localStorage.removeItem('shop');

    },
  },
  actions: {
    logout({ commit }) {
      commit('logout');
    },
  },
  getters: {
    isAuthenticated: state => !!state.token,
    shop: state => state.shop,

  }
});

export default store;
